import { render, staticRenderFns } from "./CaseStudy.vue?vue&type=template&id=99f48e0e&"
import script from "./CaseStudy.vue?vue&type=script&lang=js&"
export * from "./CaseStudy.vue?vue&type=script&lang=js&"
import style0 from "./CaseStudy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports